import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  PurchasedQuotationsStyles,
  PageHeader,
  SearchButton,
  EmptyState,
  LoadingState,
  QuotationsList,
} from '../PurchasedQuotations/PurchasedQuotations.styles';
import {
  BrokerListItemCard,
  BrokerListItemHeader,
  BrokerListItemContent,
  BrokerListItemSection,
  BrokerListItemLabel,
  BrokerListItemValue,
  BrokerListItemAction,
  BrokerListItemFilterCard,
} from '../../common/components/BrokerListItem.styles';
import { generalAlertError } from '../../common/utils/alerts';
import {
  listFastQuotes,
  resetListFastQuotes,
} from '../../features/insuranceRequests/insuranceRequestsActions';
import Pagination from '../../common/components/elements/Pagination';
import ErrorComponent from '../../common/components/ErrorComponent';
import {
  getProductNameById,
  getProductIcon,
  productsList,
} from '../../common/constants';

const emptyFilters = {
  product: '',
  vehicle_plate: '',
  date_from: '',
  date_to: '',
};

function FastQuotesPage() {
  const state = useSelector(
    (store) => store.insuranceRequests.fast_quotes_list,
  );

  const {
    loading, fast_quotes, page_number, total_pages, error,
  } = state;

  const [search, setSearch] = useState(emptyFilters);

  const searchHandler = (e) => {
    e.preventDefault();

    if (search.date_from !== '' && search.date_to === '') {
      generalAlertError('Devi selezionare anche data al');
      return;
    }

    if (search.date_from === '' && search.date_to !== '') {
      generalAlertError('Devi selezionare anche data da');
      return;
    }

    const trimmedSearch = {
      ...search,
      vehicle_plate: (search.vehicle_plate || '').trim().toUpperCase().replace(/[^A-Z0-9]/g, ''),
    };

    listFastQuotes(1, trimmedSearch);
  };

  const handleChange = ({ target: { value, name } }) => {
    setSearch({ ...search, [name]: value });
  };

  useEffect(() => () => {
    resetListFastQuotes();
  }, []);

  const getUrlTag = (product) => {
    if (product === 1) {
      return 'auto';
    }
    if (product === 4) {
      return 'profession';
    }
    if (product === 10) {
      return 'commercial';
    }

    if (product === 8) {
      return 'travel';
    }

    if (product === 15) {
      return 'rc-professionale-sanita';
    }

    if (product === 11) {
      return 'casa';
    }

    if (product === 1003) {
      return 'condominio';
    }
    if (product === 1004) {
      return 'rc-famiglia';
    }

    return product;
  };

  const getItemUrl = (fast_quote) => {
    if (fast_quote.vat_number != null) {
      return `/quote/${getUrlTag(fast_quote.product_id)}/${fast_quote.vat_number}/report`;
    }

    const subProduct = fast_quote.reference_response?.sub_product;
    const productTag = getUrlTag(fast_quote.product_id).toLocaleLowerCase();

    if (subProduct === 'professioni-sanitarie') {
      return `/quote/${productTag}/professioni-sanitarie/${fast_quote.id}`;
    }
    if (subProduct === 'medici-dipendenti') {
      return `/quote/${productTag}/medici-dipendenti/${fast_quote.id}`;
    }
    if (subProduct === 'medico-protetto') {
      return `/quote/${productTag}/medico-protetto/${fast_quote.id}`;
    }
    if (subProduct === 'medici-liberi-professionisti') {
      return `/quote/${productTag}/medici-liberi-professionisti/${fast_quote.id}`;
    }

    return `/quote/${productTag}/${fast_quote.id}`;
  };

  const formatDate = (value) => {
    if (!value) return '-';
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return '-';
    return parsed.toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  return error === null ? (
    <PurchasedQuotationsStyles>
      <div className="container-fluid">
        <PageHeader>
          <h2>⚡ Fast Quotes</h2>
        </PageHeader>

        <BrokerListItemFilterCard className="not-saved-quotations-three mb-4">
          <form onSubmit={searchHandler}>
            <div className="row g-3">
              <div className="col-md-3">
                <label htmlFor="product" className="form-label small">Prodotto</label>
                <select
                  name="product"
                  id="product"
                  className="form-select form-select-sm"
                  value={search.product}
                  onChange={handleChange}
                >
                  <option value="">Tutti i prodotti</option>
                  {productsList.map((prod) => (
                    <option key={prod.id} value={prod.id}>
                      {prod.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-3">
                <label htmlFor="vehicle_plate" className="form-label small">Targa</label>
                <input
                  type="text"
                  name="vehicle_plate"
                  id="vehicle_plate"
                  className="form-control form-control-sm"
                  value={search.vehicle_plate}
                  onChange={handleChange}
                  placeholder="Targa..."
                />
              </div>

              <div className="col-md-3">
                <label htmlFor="date_from" className="form-label small">Data creazione da</label>
                <input
                  type="date"
                  name="date_from"
                  id="date_from"
                  onChange={handleChange}
                  value={search.date_from}
                  className="form-control form-control-sm"
                  lang="it-IT"
                />
              </div>

              <div className="col-md-3">
                <label htmlFor="date_to" className="form-label small">Data creazione al</label>
                <input
                  type="date"
                  name="date_to"
                  id="date_to"
                  className="form-control form-control-sm"
                  onChange={handleChange}
                  value={search.date_to}
                  min={search.date_from}
                  lang="it-IT"
                />
              </div>
            </div>

            <div className="d-flex gap-2 mt-3" style={{ justifyContent: 'flex-start' }}>
              <SearchButton type="submit" style={{ padding: '8px 24px', fontSize: '14px', width: 'auto' }}>
                Cerca
              </SearchButton>
              <SearchButton
                type="button"
                style={{
                  background: '#6c757d', borderColor: '#6c757d', padding: '8px 24px', fontSize: '14px', width: 'auto',
                }}
                onClick={() => {
                  setSearch(emptyFilters);
                  listFastQuotes(1, emptyFilters);
                }}
              >
                Pulisci Filtri
              </SearchButton>
            </div>
          </form>
        </BrokerListItemFilterCard>

        <div className="row">
          <div className="col-12">
            {loading ? (
              <LoadingState className="not-saved-quotations-one">
                <div className="spinner-border" role="status" />
                <span>Caricamento fast quotes in corso...</span>
              </LoadingState>
            ) : (
              <>
                <QuotationsList className="not-saved-quotations-one">
                  {fast_quotes.length > 0 ? (
                    fast_quotes.map((fast_quote, index) => {
                      const productName = getProductNameById(fast_quote.product_id);
                      const createdAt = formatDate(fast_quote.created_at);

                      return (
                        <BrokerListItemCard
                          key={index}
                          className="not-saved-quotations-two"
                        >
                          <BrokerListItemHeader>
                            <div className="d-flex align-items-center gap-3">
                              <div
                                style={{
                                  lineHeight: 1,
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={getProductIcon(fast_quote.product_id)}
                                  style={{
                                    fontSize: '1.5rem',
                                    color: 'white',
                                  }}
                                />
                              </div>
                              <div className="flex-grow-1">
                                <h4>
                                  FAST QUOTE
                                  {' '}
                                  {productName ? productName.toUpperCase() : ''}
                                </h4>
                                <p>
                                  Creato il
                                  {' '}
                                  {createdAt}
                                </p>
                              </div>
                            </div>
                          </BrokerListItemHeader>

                          <BrokerListItemContent>
                            <div className="row">
                              <div className="col-md-4">
                                <BrokerListItemSection>
                                  <BrokerListItemLabel>Prodotto</BrokerListItemLabel>
                                  <BrokerListItemValue>{productName || '-'}</BrokerListItemValue>
                                </BrokerListItemSection>

                                {fast_quote.vehicle_plate && (
                                  <BrokerListItemSection>
                                    <BrokerListItemLabel>Targa</BrokerListItemLabel>
                                    <BrokerListItemValue>{fast_quote.vehicle_plate}</BrokerListItemValue>
                                  </BrokerListItemSection>
                                )}

                                {fast_quote.vat_number && (
                                  <BrokerListItemSection>
                                    <BrokerListItemLabel>Partita IVA</BrokerListItemLabel>
                                    <BrokerListItemValue>{fast_quote.vat_number}</BrokerListItemValue>
                                  </BrokerListItemSection>
                                )}

                                <BrokerListItemSection>
                                  <BrokerListItemLabel>Data Creazione</BrokerListItemLabel>
                                  <BrokerListItemValue>{createdAt}</BrokerListItemValue>
                                </BrokerListItemSection>
                              </div>

                              <div className="col-md-4">
                                <BrokerListItemSection>
                                  <BrokerListItemLabel>Garanzie incluse</BrokerListItemLabel>
                                  <BrokerListItemValue>
                                    {Array.isArray(fast_quote.guarantees) && fast_quote.guarantees.length > 0 ? (
                                      <div className="d-flex flex-column" style={{ gap: '0.4rem' }}>
                                        {fast_quote.guarantees.map((guarantee, guaranteeIndex) => (
                                          <div key={guaranteeIndex} style={{ fontSize: '0.85rem' }}>
                                            <span style={{ fontWeight: '500', color: '#333' }}>
                                              {guarantee.name}
                                              :
                                            </span>
                                            {' '}
                                            <span style={{ color: '#00a651', fontWeight: '600' }}>
                                              €
                                              {' '}
                                              {Number(guarantee.price || 0).toLocaleString('it-IT', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              })}
                                            </span>
                                          </div>
                                        ))}
                                      </div>
                                    ) : (
                                      <div style={{ color: '#888', fontSize: '0.85rem', fontStyle: 'italic' }}>
                                        Nessuna garanzia
                                      </div>
                                    )}
                                  </BrokerListItemValue>
                                </BrokerListItemSection>

                                <div style={{ marginTop: '1rem', fontSize: '0.95rem' }}>
                                  <span style={{ fontWeight: '600', color: '#333' }}>
                                    Totale:
                                  </span>
                                  {' '}
                                  <span style={{ fontSize: '1.1rem', fontWeight: '900', color: '#00a651' }}>
                                    €
                                    {' '}
                                    {parseFloat(fast_quote.total_price || 0).toLocaleString('it-IT', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </span>
                                </div>
                              </div>

                              <div className="col-md-4 d-flex flex-column">
                                <div className="mt-auto d-flex justify-content-end">
                                  <Link to={getItemUrl(fast_quote)}>
                                    <BrokerListItemAction>
                                      Vai al preventivo →
                                    </BrokerListItemAction>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </BrokerListItemContent>
                        </BrokerListItemCard>
                      );
                    })
                  ) : (
                    <EmptyState className="not-saved-quotations-no-result">
                      <div className="empty-icon">📭</div>
                      <h5>Trova con facilità le fast quotes che cerchi</h5>
                      <p>
                        Utilizza i filtri per trovare una fast quote o clicca su &quot;Cerca&quot; per visualizzare le ultime calcolate
                      </p>
                    </EmptyState>
                  )}
                </QuotationsList>

                <div className="mt-4">
                  <Pagination
                    total_pages={total_pages}
                    current_page={page_number}
                    onClick={listFastQuotes}
                    search={search}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </PurchasedQuotationsStyles>
  ) : (
    <ErrorComponent error={error} />
  );
}

export default FastQuotesPage;
